<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-07 15:58:02
-->
<template>
  <div class="box">
    <div style="display: flex; width: 100%">
      <div class="left">
        <div class="left-box">
          <div class="title">工作流列表</div>
          <a v-if="codeData.indexOf('338') != -1" @click="tabooList" class="reard-box">运行记录</a>
        </div>
        <div class="search">
           <div class="search-box">
              <div><el-input v-model="value" placeholder="按名称搜索"></el-input></div>
             <div @click="onSearch" class="icon-img"><i class="ri-search-line icon-search"></i></div>
           </div>
        </div>
        <a-spin :spinning="leftLoading">
          <div class="tree-box">
            <div
              @click="selectItem(item)"
              :class="item.id == selectGroupItem.id ? 'select-item' : ''"
              class="one"
              v-for="(item, index) in grouplist"
            >
              <div style="display: flex">
                <div :class="item.id == selectGroupItem.id ? 'title-icon' : ''">
                  <i class="ri-git-branch-line icon-img"></i>
                </div>
                <div
                  :style="{
                    color: item.id == selectGroupItem.id ? '#409EFF' : '',
                  }"
                  class="title-name"
                >
                  <span :title="item.workFlowName">{{ item.workFlowName }}</span>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </a-spin>

        <div
          v-if="codeData.indexOf('102') != -1"
          @click="addAdminFn"
          class="add-group"
        >
          <span>新增工作流</span>
          <div class="add-dir"></div>
        </div>
      </div>
      <div class="middle"></div>
      <div class="right">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane  label="基础信息" name="first">
             <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="113px"
          class="demo-ruleForm"
        >
              <el-form-item label="应用场景">
                <el-select
                 style="width:400px" 
                  @change="changeType"
                  v-model="ruleForm.type"
                  placeholder="请选择应用场景"
                >
                  <el-option label="内容发布" value="0"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item  label="工作流名称">
                <el-input
                style="width:400px"
                  v-model="ruleForm.workFlowName"
                  placeholder="请输入工作流名称"
                ></el-input>
              </el-form-item>
              <el-form-item  label="工作流说明">
                <el-input
                 style="width:400px"
                 type="textarea"
                  :rows="4"
                  v-model="ruleForm.workFlowNote"
                  placeholder="使用角色创建本工作流，非专业人士勿动"
                ></el-input>
              </el-form-item>
          <el-form-item class="bottom">
            <div class="form-bottom">
              <el-button
                :loading="loading"
                size="medium"
                 v-if="codeData.indexOf('102') != -1 || codeData.indexOf('104') != -1"
                type="primary"
                @click="saveVariable"
                >保存</el-button
              >
               <el-button
                size="medium"
                v-if="selectGroupItem.id && codeData.indexOf('106') != -1"
                type="danger"
                :loading="deleteShow"
                @click="resetForm"
                >删除</el-button
              >
            </div>
          </el-form-item>
        </el-form>
          </el-tab-pane>
          <el-tab-pane  v-if="selectGroupItem.id && codeData.indexOf('105') != -1"  label="流程设计" name="second">
              <addCustomVanables v-if="activeName=='second'" :selectGroupItem="selectGroupItem"></addCustomVanables>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { list,add,update,del } from "./custom_variables";
import addCustomVanables from './add_custom_vanables.vue';
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      grouplist: [],
      value: "",
      leftLoading: false,
      codeData: [],
      selectGroupItem: {},
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
        
      },
      activeName:'first',
      ruleForm:{
        type:undefined,
        workFlowName:'',
        workFlowNote:'',
        id:'',
      },
      rules:{},
      loading:false,
      deleteShow:false,
    };
  },
  components: {
    addCustomVanables,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    onSearch() {
      this.getList();
    },
    tabooList(){
             this.$router.push({
                path: "/index/configure/workflow_configuration/operation_records",
                query: { 
                    title: "运行记录",
                    islast:true,
                },
            });
        },
    addAdminFn() {
      this.ruleForm = {
        type:undefined,
        workFlowName:'',
        workFlowNote:'',
        id:'',
      };
      this.selectGroupItem = {};
      this.activeName = 'first';
    },
    selectItem(item){
        this.selectGroupItem = item;
        this.ruleForm = item;
        this.ruleForm.type = `${item.type}`;
        this.activeName = 'first'
    },
    changeType(){

    },
    handleClick(){

    },
    resetForm(){
        this.deleteShow = true;
        del({
          id:this.selectGroupItem.id,
        }).then((res)=>{
            if(res.code == 0){
                this.deleteShow = false;
                this.selectGroupItem = {};
                this.ruleForm = {};
                this.getList();
            }
        })
    },
    saveVariable(){
        this.loading = true;
        if(this.ruleForm.id){
            update(this.ruleForm).then((res)=>{
              if(res.code == 0){
                   this.getList();
              }
              this.loading = false;
            })
        }else{
          add(this.ruleForm).then((res)=>{
            if(res.code == 0){
                this.getList();
                this.ruleForm.id = res.data.id;
                this.selectGroupItem = this.ruleForm;
            }
            this.loading = false;
          })
        }
    },
    getList() {
      this.leftLoading = true;
      list({
        siteId: sessionStorage.getItem("siteId"),
        workFlowName: this.value,
      }).then((res) => {
        this.grouplist = res.data;
        if (res.data.length == 0) {
          this.grouplist = [];
           this.selectGroupItem = {};
           this.ruleForm = {};
        } else {
          if(!this.selectGroupItem.id){
              this.selectGroupItem = res.data[0];
          }
          this.ruleForm =  this.selectGroupItem;
          this.ruleForm.type = `${this.selectGroupItem.type}`
        }
        this.leftLoading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  width: 100%;
  height: calc(90% - 11px);
  .left {
    width: 250px;
    //height: calc(113% - 7px);
    font-size: 14px;
    color: #000;
    font-weight: 600;
    padding: 24px;
    //position: relative;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: rgba(245, 247, 250, 1);
      padding: 0 5px;
      border: rgba(245, 247, 250, 1);
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: rgba(245, 247, 250, 1);
      border:1px solid rgba(228, 231, 237, 1);
      border-right: none;
      outline:none;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    font-size: 14px;
    padding-top: 24px;
    padding-left: 20px;
    padding-right: 24px;
    padding-bottom: 33px;
    width: 500px;
    .right-name {
      padding-left: 24px;
      color: #000;
      font-weight: 600;
    }
    .log-box {
      //border-bottom: solid 1px #dcdfe6;
      display: flex;
      margin-left: 24px;
      margin-right: 24px;
      margin-top: 24px;
      .log {
        padding: 10px 20px;
        border-top: solid 1px #dcdfe6;
        border-left: solid 1px #dcdfe6;
        cursor: pointer;
        border-bottom: solid 1px #dcdfe6;
      }
      .log:last-child {
        border-right: solid 1px #dcdfe6;
        border-top-right-radius: 10px;
      }
      .log:first-child {
        border-top-left-radius: 10px;
      }
    }
  }
}
.top {
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 254px;
  }

  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
/deep/ .ant-tree {
  max-height: 630px;
  overflow: hidden;
  overflow-y: auto;
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 330px;
  margin-right: 24px;
  margin-top: -1px;
}
.middle {
  height: calc(113% - 4px);
  width: 1px;
  background: #f4f4f6;
}
.tr-one {
  display: flex;
}
.quan {
  width: 24px;
  height: 24px;
  background: #fff;
  border: solid 1px #ccc;
  border-radius: 50%;
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.one {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  border-radius: 4px;
}
.fixed-inner {
  transform: rotate(90deg);
  cursor: pointer;
}
.title-name {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto-regular;
  font-weight: 500;
  margin-left: 10px;
  overflow:hidden;
  width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
}
.add-group {
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  background-color: #176de6;
  text-align: center;
  color: #fff;
  font-weight: 500;
  width: 200px;
  position: absolute;
  bottom: 30px;
  cursor: pointer;
  z-index: 2;
}
.tree-box {
  //display: flex;
  min-height: 300px;
  align-content: space-between;
}
.fixed-inner:hover {
}
.eidt-ground {
}
/deep/ .el-dialog__body {
  padding-bottom: 0px;
}
.select-item {
  background-color: rgba(236, 245, 255, 1);
}
.title-icon {
  .icon-link-m:before {
    color: rgba(64, 158, 255, 1);
  }
}
.add-dir {
  position: absolute;
  top: -14px;
  height: 10px;
  background: #fff;
  width: 249px;
  z-index: 2;
  left: -23px;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 2px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 250px);
  padding-right: 24px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.el-button--primary {
  background: #176de6;
}
.sort-two {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.left-box {
  display: flex;
  justify-content: space-between;
  .reard-box {
    color: rgba(23, 109, 230, 1);
    font-size: 14px;
    font-family: Roboto-regular;
    font-weight: 500;
  }
}
.icon-img {
  color: rgba(102, 111, 128, 1);
}
.demo-ruleForm{
  margin-top: 52px;
}
/deep/ .el-form-item__label{
  padding: 0 34px 0 0;
}
.search-box{
  display: flex;
  align-items: center;
  border-radius: 4px;
  background-color: rgba(245, 247, 250, 1);
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
  border: 1px solid rgba(228, 231, 237, 1);
  /deep/ .el-input__inner{
    border:none;
    background-color: rgba(245, 247, 250, 1);
    color: rgba(102, 111, 128, 1);
  }
  .icon-img{
    width: 40px;
    height: 40px;
    line-height: 20px;
    border-radius: 0px 4px 4px 0px;
    background-color: rgba(240, 246, 255, 1);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .icon-search{
      font-size: 20px;
      font-weight: 600;
    }
  }
}
</style>